import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { User } from '@/api/rest/resources/types/user';
import { isNullish } from '@/utils/booleans';

import { AnalyticsEvent } from '../constants';
import { getUserBody } from '../utils';
import { captureEvent, identifyUser } from './PostHogAnalytics';

export const pageViewEvent = (path: string) => {
  captureEvent({ name: AnalyticsEvent.PAGE_VIEW, params: { path } });
};

export const logInEvent = (user: User | null, impersonatedBy?: string) => {
  if (isNullish(user)) return;

  identifyUser(user, impersonatedBy);
  captureEvent({
    name: AnalyticsEvent.USER_LOG_IN,
    params: getUserBody(user),
  });
};

export const logOutEvent = (user: User | null) => {
  if (isNullish(user)) return;

  captureEvent({
    name: AnalyticsEvent.USER_LOG_OUT,
    params: getUserBody(user),
  });
};

export const useNavigationTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    pageViewEvent(pathname);
  }, [pathname]);
};
